module.exports = __webpack_public_path__ + "assets/clearbraces.732224123f2aac81884d1b5227d2211d.png";